import React from 'react';
import { createPortal } from 'react-dom';

import useDefaultModal from './default-modal.controller';

const ID = 'default-modal';
export interface DefaultModalProps {
    id?: string;
    handleClose: () => void;
    show: boolean;
    children?: React.ReactNode;
    type?: ModalType;
    customWidth?: number;
}

export const DefaultModal = (props: DefaultModalProps) => {
    const viewProps = useDefaultModal(props);

    if (!props.show) {
        return <></>;
    }

    const root = document.getElementById('root');
    if (!root) throw new Error('Root node not found. Cannot render modal.');

    return createPortal(
        <div
            className='modal display-block'
            aria-modal='true'
            role='dialog'
            id={ID + '-' + props.id}>
            <div
                className={`${viewProps.modalType} ${props.show ? '' : 'hide'}`}
                style={viewProps.width}
                ref={viewProps.modalRef}>
                {props.children}
            </div>
        </div>,
        root
    );
};

export enum ModalType {
    PROMPT = 'prompt',
    PANE = 'pane',
    MOBILE_BOTTOM = 'mobile-bottom',
    BOTTOM = 'bottom'
}
